var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 61.28,
    viewBox: "0 0 68 61.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 68,
    height: 61.28,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M34,61.279l-1.4-.924C20.418,52.237,0,36.469,0,21.922,0,9.452,8.772.047,20.4.047,24.938.047,29.2,2,34.007,6.342c10.317-9.163,21.146-7.523,27.927-.628A22.338,22.338,0,0,1,68,21.969c-.236,15.2-22.88,31.908-32.6,38.386ZM20.4,5.107c-8.886,0-15.337,7.071-15.337,16.814,0,8.556,10.782,20.93,28.939,33.271,14.142-9.655,28.778-23.184,28.939-33.312A17.335,17.335,0,0,0,58.324,9.263c-5.209-5.3-13.495-6.639-22.543,2.355L34,13.393l-1.788-1.775c-4.521-4.5-8.164-6.511-11.815-6.511",
    transform: "translate(0 0.002)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon10);
export default __webpack_public_path__ + "static/media/social_icon10.c004b621af41fef7652e4edf3f6ad224.svg";
export { ForwardRef as ReactComponent };